import { VITE_AZURE_AUTHORITY, VITE_AZURE_CLIENTID } from './sys';

export const msalConfig = {
  auth: {
    clientId: VITE_AZURE_CLIENTID,
    authority: VITE_AZURE_AUTHORITY,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export default msalConfig;
